'use strict';

import defaultTemplate from '../../core/default.html';
import callCenterEditTemplate from './callcenter.edit.html';

import CallCenter from './callcenter.ctrl';
import EditLocationDataProviderModule from '../locations/edit/editLocationDataProvider';

function CallCenterRouter($urlRouterProvider, $stateProvider) {
  $stateProvider
    .state('main.callcenter', {
      url: '/callcenter',
      template: defaultTemplate
    })
    .state('main.callcenter.edit', {
      url: '/edit?:tab&:from&:locationId',
      template: callCenterEditTemplate,
      controller: 'CallCenterEditController as vm'
    });
}

export default angular
  .module('callcenter.router', [
    EditLocationDataProviderModule,
    CallCenter
  ])
  .config(CallCenterRouter)
  .name;
